/**
 * The one order every client list takes (LP-19, Amanda: "You should sort
 * everyone by first name"): by display name, which reads first name first,
 * compared the way All clients compares it. My Clients and All clients use
 * this comparator, so the same people read in the same order on both.
 */
export function byDisplayName(a: { display_name: string }, b: { display_name: string }): number {
  return a.display_name.localeCompare(b.display_name);
}
